export const environment = {
    mdmApiUrl: 'https://backend-dev.slipstreammdm.com/api/mdm/',
    apiUrl: 'https://backend-dev.slipstreammdm.com',
};
